import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { urls } from 'helpers/url';
import { navigate } from 'actionCreators';
import { updatePhaseTask } from 'actionCreators/phase';
import PhaseTask from './phase_task';
import PhaseType from 'types/phase';
import TaskType from 'types/task';

export class ContractVerificationChecklist extends PhaseTask {
  isDisabled = () => false

  onClick = () => {
    if (this.props.task.status !== 'complete') this.props.navigate(urls.phaseCvChecklist(this.props.phase));
  }
}

ContractVerificationChecklist.propTypes = {
  phase: PhaseType.isRequired,
  task: TaskType.isRequired,
  updatePhaseTask: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
};

export const cv_checklist = connect(() => state => ({
  user: state.user,
}), { updatePhaseTask, navigate })(ContractVerificationChecklist);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/cv_checklist.jsx